import { render } from "./PhotosByParticipantTable.vue?vue&type=template&id=7278f3ee"
import script from "./PhotosByParticipantTable.vue?vue&type=script&lang=js"
export * from "./PhotosByParticipantTable.vue?vue&type=script&lang=js"
script.render = render

export default script